import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import { Dialog } from "@natera/material/lib/dialog";
import { Button } from "@natera/form";

import { useNavigate } from "react-router-dom";
import { routes } from "@app/routing";
import "./drawRequestDialog.scss";

const messages = defineMessages({
  drawRequestBack: {
    id: "drawRequestBack",
    defaultMessage: "Back To Home",
  },
});

interface DrawRequestDialogProps {
  title: string;
  description?: string;
}

const DrawRequestDialog: FC<DrawRequestDialogProps> = ({
  title,
  description,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(routes.home);
  };

  return (
    <div className="draw-request-dialog">
      <Dialog
        title={title}
        actions={
          <Button unelevated onClick={handleBack}>
            {intl.formatMessage(messages.drawRequestBack)}
          </Button>
        }
        onClose={handleBack}
      >
        <div className="draw-request-dialog__content">{description}</div>
      </Dialog>
    </div>
  );
};

export default DrawRequestDialog;
